module.exports = __webpack_public_path__ + "static/img/9.fbddc99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clientes/9.png
// module id = k/dL
// module chunks = 0